import useSWR from 'swr';
import { useMemo } from 'react';
// utils
import { fetcher, endpoints } from 'src/utils/api-client';

// ----------------------------------------------------------------------

// Entitlements do usuário logado. Formato: { inventory: { enabled, device_ids } }.
// Usado para gatear menus/telas por plano da usina (ver backend entitlements.py).
export function useGetMyFeatures() {
  const URL = endpoints.auth.meFeatures;

  const { data, isLoading, error, isValidating } = useSWR(URL, fetcher, {
    revalidateIfStale: true,
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
  });

  return useMemo(
    () => ({
      features: data || {},
      featuresLoading: isLoading,
      featuresError: error,
      featuresValidating: isValidating,
    }),
    [data, error, isLoading, isValidating]
  );
}

// Conveniência: uma feature específica está habilitada?
export function useHasFeature(feature) {
  const { features, featuresLoading } = useGetMyFeatures();
  return {
    enabled: Boolean(features?.[feature]?.enabled),
    loading: featuresLoading,
  };
}
